<template>
  <div class="logo-what-not-content" id="identidade-visual-logo-o-que-nao-fazer" data-search-anchor>
    <div class="title-what-not-wrapper">
      <h1 class="logo-what-not-title-span">{{ logoWhatNotToDoTitleSpan }}</h1>
      <h1 class="logo-what-not-title">{{ logoWhatNotToDoTitle }}</h1>
    </div>

    <div class="description-what-not-wrapper">
      <div>
        <p class="logo-what-not-description">{{ logoWhatNotToDoDescription }}</p>
      </div>

      <div class="logo-what-not-icon-wrapper-icon">
        <p class="fica-a-dica-not-do">{{ logoWhatNotToDoDescription1 }}</p>
        <div class="logo-what-not-text-icons">
          <IconCancel />
          <p class="logo-what-not-description-second-title">
            {{ logoWhatNotToDoDescription2 }}
          </p>
        </div>
      </div>
    </div>

    <div
      class="logo-what-not-card-item"
      :style="{ backgroundImage: `url(${logoWhatNotToDoImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import IconCancel from '@/assets/icons/IconCancel.vue'

@Component({
  components: {
    IconCancel    
  }
})
export default class LogoWhatNotToDoSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoWhatNotToDoTitleSpan(): string {
    return this.getElementTitle(20, 0)
  }

  get logoWhatNotToDoTitle(): string {
    return this.getElementText(20, 0)
  }

  get logoWhatNotToDoDescription(): string {
    return this.getElementText(20, 1)
  }

  get logoWhatNotToDoDescription1(): string {
    return this.getElementText(20, 2)
  }

  get logoWhatNotToDoDescription2(): string {
    return this.getElementText(20, 3)
  }

  get logoWhatNotToDoImageSrc(): string {
    return this.getElementMedia(20, 4)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-what-not-content {
  width: 100%;
  display: grid;
  max-width: 1032px;
}

.title-what-not-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.logo-what-not-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-what-not-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-what-not-wrapper {  
  position: relative;  
  max-width: 1032px;
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;  
}

.logo-what-not-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
 
  width: 430px;
}

.fica-a-dica-not-do{
  font-size: 16px;  
  line-height: 20px;
  text-align: left;  
  width: 430px;
  margin-bottom: 0.5rem; 
  font-family: InterVariableBold;
}

.logo-what-not-description-second-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding-left: 7px;  
  width: 100%;
}

.logo-what-not-description-second {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  margin: 0;
  padding-left: 7px;
  width: 430px;
}

.logo-what-not-icon-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1032px;  
}

.logo-what-not-card-item {
  position: relative;
  bottom: 0;  
  width: 100%;
  max-width: 1032px;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.logo-what-not-text-icons{
  display: flex;
  align-items: center;  
}
</style>
